import { addQueryToUrl } from 'app/frontend-lib/tools/utils'
import { versionfunegt, GetQueryString } from 'lib/tools/utils'
import Router from 'vue-router'
import { Base64 } from 'js-base64'
import { inMiniProgramWebview } from 'utils/tool.js'

const isServer = process.env.VUE_ENV === 'server'
if (!isServer) {
  // import { addUrlParams } from 'lib/tools/url'
  const VueRouterPush = Router.prototype.push
  Router.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
  }
}
export default {
  methods: {
    hasOrigin(url) {
      // return /(^http:\/\/|https:\/\/|yixinli:\/\/)(([A-Za-z0-9-~]+).)+([A-Za-z0-9-~\/])+$/.test(url)
      return /(^http:\/\/|https:\/\/|yixinli:\/\/|muse:\/\/)/.test(url)
    },
    /**
     * 跳转路由
     * @param {String||Object} route
     * @param {String} origin
     */
    routerReplace(route, origin = window.location.href, mode = 'history') {
      if (
        this.$getMP &&
        Object.prototype.toString.call(route) === '[object Object]'
      ) {
        route.query = {
          ...this.$route.query,
          ...route.query
        }
      }
      let _route = this.$router
      if (mode !== 'history') {
        _route = new Router({
          mode
        })
      }
      // 转字符串
      let url = typeof route === 'string' ? route : _route.resolve(route).href
      // 是不是本项目内链接
      const isNodeWebsite =
        origin === window.location.href && !this.hasOrigin(url)
      // 如果没有origin+不是本站，说明需要origin
      if (!this.hasOrigin(url) && !isNodeWebsite) {
        url = origin + url
      }

      if (isNodeWebsite && this.$platform.isYixinliApp) {
        url = window.location.origin + url
      }
      if (this.$runningEnv.env.indexOf('box') === 0) {
        // eslint-disable-line
        url = url.replace('https://', 'http://')
      }
      // 替换环境
      if (this.$runningEnv.env && url.indexOf(this.$runningEnv.env) === -1) {
        url = url.replace(
          '.xinli001.com',
          `-${this.$runningEnv.env}.xinli001.com`
        )
        url = url.replace(
          '.onexinli.com',
          `-${this.$runningEnv.env}.onexinli.com`
        )
      }
      // 如果是本站
      if (isNodeWebsite) {
        let origin = location.origin
        // eslint-disable-line
        origin =
          this.$runningEnv.env.indexOf('box') === 0
            ? origin.replace('https://', 'http://')
            : origin
        url = url.replace(origin, '')
        this.$router.replace(url)
        // 其他情况
      } else {
        console.log('location href jump', url)
        window.location.replace = url
      }
    },
    /**
     * 跳转路由
     * @param {String||Object} route
     * @param {Boolean} isOpenWebview 在app内是否用新的webview 打开
     * @param {String} origin
     */
    routerPush(
      route,
      origin = window.location.href,
      isOpenWebview = true,
      mode = 'history',
      hideNavigationBar = false
    ) {
      if (
        this.$getMP &&
        Object.prototype.toString.call(route) === '[object Object]'
      ) {
        route.query = {
          ...this.$route.query,
          ...route.query
        }
      }
      // 支持第二个参数如果是boolean，当作isOpenWebview来用
      typeof origin === 'boolean' && (isOpenWebview = origin)
      let _route = this.$router
      if (mode !== 'history') {
        _route = new Router({
          mode
        })
      }

      // 转字符串
      let url = typeof route === 'string' ? route : _route.resolve(route).href
      url = addQueryToUrl(url, {
        page: Base64.encodeURI(this.$route.meta.pageName)
      })

      // 神策
      // 某些场景需要写死_source_page_，如个人主页跳下单页
      const trackParams = this.$getTrackRunWithRouteQuerys({
        _source_page_: route?.query?._source_page_
          ? route.query._source_page_
          : ''
      })
      url = addQueryToUrl(url, trackParams)

      const { isYixinliApp, isZiXunApp } = this.$platform
      const isApp = isYixinliApp || isZiXunApp
      // 是不是本项目内链接
      const isNodeWebsite =
        origin === window.location.href && !this.hasOrigin(url)
      // 如果没有origin+不是本站，说明需要origin
      if (!this.hasOrigin(url) && !isNodeWebsite) {
        url = origin + url
      }

      if (isNodeWebsite && (isApp || inMiniProgramWebview())) {
        url = window.location.origin + url
      }
      if (
        this.$runningEnv.env.indexOf('box') === 0 &&
        !inMiniProgramWebview()
      ) {
        // eslint-disable-line
        url = url.replace('https://', 'http://')
      }
      // 替换环境
      if (this.$runningEnv.env && url.indexOf(this.$runningEnv.env) === -1) {
        url = url.replace(
          '.xinli001.com',
          `-${this.$runningEnv.env}.xinli001.com`
        )
        url = url.replace(
          '.onexinli.com',
          `-${this.$runningEnv.env}.onexinli.com`
        )
      }
      // 如果是协议，不在新的webview 打开
      if (url.indexOf('yixinli://') === 0 || url.indexOf('muse://') === 0) {
        isOpenWebview = false
      }
      // 如果是app，而且要新开webview
      if (isApp && isOpenWebview) {
        // 倾诉下单页要隐藏头部，客户端那边还没加上这个方法，暂时先在这里统一判断一下隐藏头部
        if (url.indexOf('msite/index.html#/qingsu-order-page') > -1) {
          hideNavigationBar = true
        }
        this.$bridge.openWebView({
          url,
          isCurrentPageOpen: isOpenWebview ? 0 : 1,
          hideNavigationBar: hideNavigationBar ? 1 : 0
        })
      } else if (inMiniProgramWebview()) {
        // 小程序
        this.$uniAppNavto.push({
          path: '../webView/webView?src=' + encodeURIComponent(url)
        })
      } else if (isNodeWebsite) {
        // 如果是本站
        url = url.replace(location.origin, '')
        console.log('isNodeWebsite', url)

        this.$router.push(url)
      } else {
        // 其他情况
        console.log('location href jump', url)

        window.location.href = url
      }
    },
    routerPushWithoutNav(
      route,
      origin = window.location.href,
      isOpenWebview = true,
      mode = 'history'
    ) {
      this.routerPush(route, origin, isOpenWebview, mode, true)
    },
    /**
     * 返回
     * @param {Boolean} isCancelWebview
     */
    routerGoback(isCancelWebview = true) {
      const { isYixinliApp, isZiXunApp } = this.$platform
      const isApp = isYixinliApp || isZiXunApp
      if (isApp && isCancelWebview) {
        this.$bridge.cancelWebView()
      } else {
        this.$router.go(-1)
      }
    },
    routerToStaic(route, isOpenWebview = true) {
      return this.routerPush(
        route,
        `https://static.xinli001.com/msite/index.html`,
        isOpenWebview,
        'hash'
      )
    },
    // 冥想业务已经拆分，非冥想业务不要使用当前方法
    routerToMediWithVersion(route) {
      // 添加版本判断的一个方法，用于处理5.8.2之前和之后的版本差异，
      // 5.8.2之前，不要用openWebview打开新窗口，
      // 5.8.2 和之后的版本使用openWebview，因为已经支持原生播放器
      let openWebview = true
      if (this.$platform.isYixinliApp) {
        openWebview = versionfunegt(this.$platform.yixinliAPPVersion, '5.8.2')
      }
      this.routerToMedi(route, openWebview)
    },
    // 冥想业务已经拆分，非冥想业务不要使用当前方法
    routerToMedi(route, origin = window.location.href, isOpenWebview = true) {
      console.log('route', route, origin, isOpenWebview)
      if (typeof origin === 'boolean') {
        isOpenWebview = origin
        origin = window.location.href
      }
      let _route = this.$router
      //后台配置的域名为onexinli,如果在冥想项目且是冥想星球app - ios端，则将域名改为yixinli001
      if (
        typeof route === 'string' &&
        route.indexOf('onexinli.com/meditation') >= 0 &&
        this.$platform.isMuseApp &&
        /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
      ) {
        route = route.replace('onexinli.com', 'xinli001.com')
      }
      let url =
        typeof route === 'string'
          ? route
          : window.location.protocol +
            '//' +
            window.location.host +
            _route.resolve(route).href
      //需要登录的点击使用路由跳转避免出现先进入未登录页面在跳转的情况
      //已登录：统一开新页面
      if (this.$platform.isMuseApp) {
        console.log('isMuseApp')
        if (this.$bus.userOtherInfo && this.$bus.userOtherInfo.isLogin === 1) {
          console.log('isMuseApp and isLogin')
          if (
            url.indexOf('/meditation/vip') > 0 &&
            /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) &&
            versionfunegt(this.$platform.museAPPVersion, '1.0.3') // museApp version 1.0.3 at least to go this way
          ) {
            console.log('muse app open vip')
            window.location.href = url
          } else {
            console.log('muse app open others')
            this.$bridge.openWebView({
              url,
              isCurrentPageOpen: 0
            })
          }
        } else {
          //未登录
          if (typeof route === 'string') {
            let localUrl =
              window.location.protocol + '//' + window.location.host
            //项目内 用路由push
            if (route.indexOf(localUrl) === 0) {
              window.location.href = 'muse://open_user_login'
            } else {
              //项目外 重新开页面
              this.$bridge.openWebView({
                url,
                isCurrentPageOpen: 0
              })
            }
          } else {
            window.location.href = 'muse://open_user_login'
          }
        }
      } else {
        console.log('muse app open others')
        if (typeof route === 'string') {
          window.location.href = route
        } else {
          console.log('冥想路由跳转', route)
          this.routerPush(route, origin, isOpenWebview)
        }
      }
    },
    toMediTab(route, reload = 0) {
      if (this.$platform.isMuseApp) {
        this.$bridge.call('openMainPageByTab', {
          tabIndex: 0
        })
        if (reload) {
          this.$bridge.call('reloadAllWebView')
        }
      } else if (
        this.$getMP &&
        Object.prototype.toString.call(route) === '[object Object]'
      ) {
        route.query = {
          ...this.$route.query,
          ...route.query
        }
        this.$router.push(route)
      } else {
        this.$router.push(route)
      }
    },
    // 去登陆
    toLogin() {
      const { isYixinliApp, isZiXunApp } = this.$platform
      let href
      if (isYixinliApp || isZiXunApp) {
        href = 'yixinli://open_user_login'
      } else {
        const { env } = this.$runningEnv
        let next = window.location.href
        try {
          next =
            window.location.origin.replace('xinli001.xin', 'xinli001.com') +
            window.location.href.replace(window.location.origin, '')
        } catch (err) {
          console.log(err)
          next = window.location.href
        }
        href = `https://m${
          env ? '-' + env : ''
        }.xinli001.com/account/login?next=${encodeURIComponent(next)}`
      }

      if (inMiniProgramWebview()) {
        href += '&hiddenThirdLogin=true'
      }

      this.routerPush(href)
    },

    // 广告位跳转
    /**
     *
     * @param obj
     *
     *  path: 如果存在该字段则使用router.push(path)跳转
     */
    toAdPage(obj) {
      if (typeof obj === 'string') {
        obj = {
          url: obj,
          object_name: ''
        }
      }
      //todo:需要运营手动配置hidenav参数隐藏头部
      const hideNavigationBar = GetQueryString('hidenav', obj.url)
      const { isYixinliApp, isZiXunApp } = this.$platform
      if (obj.object_name !== 'static' && obj.object_name !== '') {
        // 后端判断了ua
        window.location.href = obj.url
      } else {
        // 不能使用routePush，一些广告位测试需要跳转到线上
        if (isYixinliApp || isZiXunApp) {
          this.$bridge.openWebView({
            url: obj.url,
            isCurrentPageOpen: 0,
            hideNavigationBar: hideNavigationBar ? 1 : 0
          })
        } else {
          if (obj.path) {
            this.$router.push(obj.path)
          } else {
            window.location.href = obj.url
          }
        }
      }
    }
  }
}
